﻿import select2 from "select2";
import '@fortawesome/fontawesome-free/js/all';
import 'bootstrap';
import "select2/dist/css/select2.min.css";
//import common from "../../components/common.js";

import Modal from "../bootstrap.modalhelper.js";
import NotificationsHelper from "../notifications-helper.js";

export default class SwitchSchool {
    constructor(modalId, loader, urlGetConnectionsForSchoolSwitcher, urlGetSwitchSchoolForm, urlGetSchoolsList) {
        this.loader = loader;
        this.modal = new Modal(modalId);
        this.urlGetConnectionsForSchoolSwitcher = urlGetConnectionsForSchoolSwitcher;
        this.urlGetSwitchSchoolForm = urlGetSwitchSchoolForm;
        this.urlGetSchoolsList = urlGetSchoolsList;

        this.notificationHelper = new NotificationsHelper();
        this.menuItemsId = "#school-switcher .dropdown-menu";
        this.xhrLoadingSchools = false;
    }

    init() {
        let thisClass = this;

        // Load switch connection form
        $(document).on("click", ".select-school-profile", function (event) {
            event.preventDefault();
            var link = $(this);
            var schoolId = link.data("schoolId");
            var employeeId = link.data("employeeId");
            var userProfileId = link.data("userProfileId");

            thisClass.modal.show("Switch school connection", thisClass.loader);

            $.ajax({
                url: thisClass.urlGetSwitchSchoolForm,
                type: "GET",
                dataType: "html",
                data: {
                    SchoolId: schoolId,
                    EmployeeId: employeeId,
                    userProfileId: userProfileId
                },
                traditional: true,
                success: function (result) {
                    thisClass.modal.setBody(result);
                    thisClass.InitSelect2();
                },
                error: function (e) {
                    thisClass.notificationHelper.addError("Request failed.")
                    thisClass.notificationHelper.showNotifications();
                    thisClass.modal.setBody('<div class="text-danger">Request failed!</div>');
                }
            });
        });


        // Load connection list dropdown menu
        $("#school-switcher.dropdown").on("shown.bs.dropdown", function () {
            if (thisClass.xhrLoadingSchools == true)
                return false;
            var menu = $(this);

            if (menu.find('.dropdown-menu a').length > 0) {
                return false;
            }
            thisClass.xhrLoadingSchools = true;
            var userProfileId = menu.data("userProfileId"); 

            $(thisClass.menuItemsId).html(thisClass.loader);

            $.ajax({
                url: thisClass.urlGetConnectionsForSchoolSwitcher,
                type: "GET",
                traditional: true,
                data: {
                    id: userProfileId
                },
                success: function (result) {
                    thisClass.xhrLoadingSchools = false;
                    $(thisClass.menuItemsId).html(result);
                },
                error: function () {
                    thisClass.xhrLoadingSchools = false;
                    $(thisClass.menuItemsId).html('<div class="dropdown-item text-danger" href="#">Failed to load connections</div>');
                }
            });
        });

        // Handle update connection form
        $(thisClass.modal.modal).on("submit", "#switch-school-form", function (event) {
            event.preventDefault();
            event.stopPropagation();
            thisClass.modal.setBody(thisClass.loader);

            var form = $(this);

            $.ajax({
                url: form.attr("action"),
                type: "POST",
                data: form.serialize(),
                success: function (result) {
                    if (result.hasErrors) {
                        thisClass.modal.setBody(result.view);
                        thisClass.InitSelect2();
                    } else {
                        thisClass.notificationHelper.addSuccess("Connection updated.");
                        thisClass.notificationHelper.showNotifications();
                        thisClass.modal.hide();
                    }
                },
                error: function () {
                    thisClass.modal.hide();
                    thisClass.notificationHelper.addError("Request failed.")
                    thisClass.notificationHelper.showNotifications();
                }
            });
        });
    }

    InitSelect2() {
        var thisClass = this;
        //$("#NewSchoolId").select2({
        //    dropdownParent: thisClass.modal.modal,
        //    placeholder: "Select school",
        //    allowClear: true,
        //    width: "100%"
        //});
        $("#NewSchoolId").select2({
            dropdownParent: thisClass.modal.modal,
            placeholder: "Name of school or Brin",
            allowClear: true,
            width: "100%",
            minimumInputLength: 3,
            //templateResult: thisClass.formatResult,
            ajax: {
                url: thisClass.urlGetSchoolsList,
                dataType: 'json',
                delay: 250,
                data: function (params) {
                    var urlQuery = {
                        query: params.term,
                        page: params.page || 1
                    }
                    return urlQuery;
                },
                processResults: function (data) {
                    return {
                        results: thisClass.formatResult(data.data)
                    };
                }
            }
        })
    }

    formatResult(schools) {
        var data = [];
        $(schools).each(function(idx, school) {
            var text = "";
            if (school.city == null) {
                text = `${school.brinCode} - ${school.name}`;
            } else {
                text = `${school.brinCode} - ${school.name}, ${school.city}`;
            }
            data.push({
                id: school.id,
                text: text
            });
        });
        return data;
    }
}